// What the practice says to a patient whose self-booked time has been confirmed.
//
// The booking page tells the patient "the practice will confirm this with you
// shortly". Until now nothing did — staff had no way to confirm a tentative
// appointment at all, so the promise was unbacked. This is the other half of it.
//
// Sibling of cancellationNotice, and deliberately the same shape: one function,
// a pre-formatted `when`, no sending. It produces text for the reply box, and a
// human presses Send — which is also what puts it in the conversation history.

type Confirmation = {
  patientName: string;
  /** Already formatted for a person: "Monday 14 September at 1:00 PM". */
  when: string;
  /** The provider's name, when it is known. */
  providerName?: string;
};

const firstName = (full: string): string =>
  String(full || '').trim().split(/\s+/)[0] || 'there';

export function bookingConfirmation({ patientName, when, providerName }: Confirmation): string {
  const who = providerName ? ` with ${providerName}` : '';
  // States it as settled, because that is what the patient is waiting to hear.
  // The time comes first: it is the only part they need to act on.
  const opening = when
    ? `your appointment on ${when}${who} is confirmed.`
    : `your appointment${who} is confirmed.`;
  return `Hi ${firstName(patientName)} — ${opening} If you need to change it, just reply to this message.`;
}
